export class WhatsappRequest {
    MediaUrl : string; //Stores the url of the media to be sent
    Mesage : string; //Text message to be sent if any, will be displayed as caption in case of file
    FileName: string; //Name of file to be sent
    HasMedia: boolean; // Has media or not
    MessageDocumentType: DocumentType; //Message type, to be selected from different types
}

export enum DocumentType {
    msgtype_propertydocument = 10,
    msgtype_ownerdocument = 20,
    msgtype_propertysheet = 30,
    msgtype_propertyimage = 40
}